export default "__VITE_ASSET__DLbrl3TM__"